import type { AccountType, ProductIdentifier } from "@s2z-platform/constants";
import {
  productIdentifiers,
  productIdentifiersByAccountType,
} from "@s2z-platform/constants";

export function getAllProductsExcept(
  productsToExclude: ProductIdentifier[],
  accountType?: AccountType,
) {
  let productPool = productIdentifiers;
  if (accountType) productPool = productIdentifiersByAccountType[accountType];
  return productPool.filter((pI) => !productsToExclude.includes(pI));
}
